var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialTgC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "#37AEE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44487 5.61302L6.76727 3.83212C7.19395 3.6466 8.64093 3.05297 8.64093 3.05297C8.64093 3.05297 9.30877 2.79325 9.25312 3.42399C9.23456 3.68371 9.08616 4.59271 8.93775 5.57592L8.47397 8.48843C8.47397 8.48843 8.43687 8.91511 8.1215 8.98931C7.80613 9.06352 7.2867 8.7296 7.19395 8.65539C7.11974 8.59974 5.80262 7.76494 5.32029 7.35682C5.19043 7.24551 5.04202 7.0229 5.33884 6.76318C6.00668 6.151 6.80437 5.39041 7.2867 4.90808C7.50932 4.68546 7.73193 4.16603 6.80438 4.79677L4.18867 6.55912C4.18867 6.55912 3.89186 6.74463 3.33532 6.57767C2.77879 6.41071 2.1295 6.1881 2.1295 6.1881C2.1295 6.1881 1.68428 5.90983 2.44487 5.61302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTgC);
export default __webpack_public_path__ + "static/media/social_tg_c.c21076f0f5233bd600602b95eaac3f90.svg";
export { ForwardRef as ReactComponent };